import { Col, Row} from "antd";

const AvatarPopover = ({ infoAddress }) => {

    return (
        <Row align="top" wrap={false}>
            <Col className="center-elements">
                <div
                    className="center-elements"
                    style={{
                        width: 45,
                        height: 45,
                        borderRadius: '50%',
                        overflow: 'hidden',
                        margin: '0 5px 15px 0',
                    }}
                >
                    <img
                        src={"/img/icons/ubicacion.png"} 
                        alt="profile-pic"
                        className="profile-img-sidebar"
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                    />
                </div>
            </Col>
            <Col>
                <Row>
                    <span className="user-name">{infoAddress?.displayText}</span>
                </Row>
                <Row style={{ lineHeight: '15px' }}>
                    <span className="user-nick">{infoAddress?.formattedAddress}</span>
                </Row>
            </Col>
        </Row>
    );
};

export default AvatarPopover;